import { createStore } from 'vuex'
import AuthStore from "@/store/AuthStore"
import {LocalStoragePlugin} from "@/store/LocalStoragePlugin"

export const RootStore = createStore({
  modules: {
    // common: CommonStore,
    auth: AuthStore,
  },
  plugins: [LocalStoragePlugin.plugin]
})

/**
 * Key for local storage.
 *
 * Set the key to use in local storage to hold persistant data. If logged in,
 * you can see this key by going to Chrome > dev tools > application tab,
 * then choosing "Local Storage" and "http://localhost:8080".
 *
 * @type {string}
 */
const StorageKey = 'marketing'

LocalStoragePlugin.init(StorageKey)
